"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RightSideMenu',
  props: {
    selectedLeftKey: {
      type: String,
      default: 'home'
    }
  },
  data: function data() {
    return {
      // 根据左侧菜单选择定义不同的右侧菜单选项
      menuConfig: {
        home: [{
          key: '1-1',
          label: '轮播图'
        }, {
          key: '1-2',
          label: '点餐icon'
        }, {
          key: '1-3',
          label: '底部导航栏'
        }, {
          key: '1-4',
          label: '首页公告'
        }, {
          key: '1-5',
          label: '底部颜色'
        }, {
          key: '1-6',
          label: '背景颜色'
        }, {
          key: '1-7',
          label: '金刚区'
        }],
        welfare: [{
          key: '2-1',
          label: '背景图'
        }],
        pointsMall: [{
          key: '3-1',
          label: '资源位'
        }, {
          key: '3-2',
          label: 'Tab栏'
        }, {
          key: '3-3',
          label: '积分商城背景图'
        }],
        recharge: [{
          key: '4-1',
          label: '背景图配置'
        }, {
          key: '4-2',
          label: '充值完成页配置'
        }],
        menu: [{
          key: '5-1',
          label: '轮播图'
        }
        // { key: '5-2', label: '一级菜单' }
        ],
        cart: [{
          key: '6-1',
          label: '购物车配置'
        }],
        checkout: [
          // { key: '7-1', label: '结算页配置' },
        ],
        paymentDone: [{
          key: '8-1',
          label: '支付完成页配置'
        }, {
          key: '8-2',
          label: '支付完成页banner'
        }],
        orderPay: [{
          key: '15-1',
          label: '储值弹窗配置'
        }],
        orderDetail: [{
          key: '9-1',
          label: '订单详情页配置'
        }],
        communityHome: [{
          key: '10-1',
          label: '轮播图'
        }, {
          key: '10-2',
          label: '底部导航栏'
        }, {
          key: '10-3',
          label: '首页-探索'
        }, {
          key: '10-4',
          label: '首页-活动'
        }],
        communityDay: [{
          key: '11-1',
          label: '会员日'
        }],
        communityCenter: [{
          key: '12-1',
          label: '底部轮播图'
        }],
        tablePredetermine: [{
          key: '13-1',
          label: 'table预定菜单页背景图'
        }, {
          key: '13-2',
          label: '确认按钮颜色配置'
        }],
        groupOrder: [{
          key: '14-1',
          label: '团餐规则'
        }, {
          key: '14-2',
          label: '团餐订单详情页图片'
        }, {
          key: '14-3',
          label: '团餐落地页图片'
        }]
      }
    };
  },
  computed: {
    currentMenuItems: function currentMenuItems() {
      return this.menuConfig[this.selectedLeftKey] || this.menuConfig.home;
    },
    defaultActive: function defaultActive() {
      return this.currentMenuItems.length > 0 ? this.currentMenuItems[0].key : '';
    }
  },
  watch: {
    selectedLeftKey: {
      handler: function handler(newKey) {
        var _this = this;
        // 当左侧菜单改变时，自动选中第一个右侧选项
        this.$nextTick(function () {
          if (_this.currentMenuItems.length > 0) {
            var firstItem = _this.currentMenuItems[0];
            _this.$emit('select', firstItem);
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    onMenuSelect: function onMenuSelect(key) {
      var selectedItem = this.currentMenuItems.find(function (item) {
        return item.key === key;
      });
      this.$emit('select', selectedItem);
    }
  }
};